import { render, staticRenderFns } from "./CardDeposit.vue?vue&type=template&id=0c83afe2&scoped=true"
import script from "./CardDeposit.vue?vue&type=script&lang=js"
export * from "./CardDeposit.vue?vue&type=script&lang=js"
import style0 from "./CardDeposit.vue?vue&type=style&index=0&id=0c83afe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83afe2",
  null
  
)

export default component.exports